import React, { useEffect } from "react";
import { AppBar, Button, CircularProgress, CssBaseline, Fab, Hidden, IconButton, Toolbar, } from '@material-ui/core';
import { useStylesBA, useStylesCAB, } from "../../../../../St/comps/UseStyle";
import toast, { Toaster } from "react-hot-toast";
import CloseIcon from '@material-ui/icons/Close';
import SearchIcon from '@material-ui/icons/Search';
import AddBoxIcon from '@material-ui/icons/AddBox';
import SaveIcon from '@material-ui/icons/Save';
import Delete from '@material-ui/icons/Delete';
import PrintIcon from '@material-ui/icons/Print';
import { Fragment } from "react";
import { PrepareDataWithOmla, ReFormatingMultiData } from "../../../../../services/multi-receipt-services";
import { useState } from "react";
import { stElemnt } from "../../../../../St/comps/cStyle";
import moment from "moment";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { insh, sto } from "../../../../../Context/InshData";
import MultiSandsSearchCon from "./MultiSandsSearch/MultiSandsSearchCon";
import { uri } from "../../../../../help/Api";
import axios from "axios";
import ButtonsSearch from "../components/ButtonsSearch";
import { reloadGetsSanad } from "../external-receipt-voucher/EReceiptVoucher";
import DeleteConfirmDialog from "../../../../../components/DeleteConfirmDialog";
import PrintMultiSands from "../../../../../Reviews/Accounts/MultiSQ/PrintMultiSands";
import { GetItemFromOptions } from "../../../../../services/global-services";

export default function MReceiptVoucherAppBar(props) {
  const {
    submit,
    isReceipt,
    isDialog,
    onClose,
    prmis,
    update,
    defaultV,
    remove,
    submitting,
    onShow,
    object,
    URL,
    formType,
    getRow,
    AutoOptions,
    branch,
    branchT,
    setBranchT,
    AutoOptionsB,
    setOptionsStocks,
    addArchaive,
    file,
  } = props;
  const { t } = useTranslation(['forms']);
  let his = useHistory();
  const [openSearchMdl, setOpenSearchMdl] = useState(false);
  const [openButtonsSearch, setOpenButtonsSearch] = useState(false);
  const [procIdSearch, setProcIdSearch] = useState(0);
  const [transition, setTransition] = React.useState(undefined);


  const handCloseDw = () => {

    setOpenSearchMdl(false);
  };

  const handOpenDw = (Transition) => {
    setTransition(() => Transition);

    setOpenSearchMdl(true);
  };
  const clasBA = useStylesBA();
  const clasCAB = useStylesCAB();
  const styBtn = {
    dis: { color: '#3b773d', background: '#4fa152' },
    undis: { color: '#fff' },
  }
  const newEReceipt = () => {
    // onShow(defaultV, 'new');
    setOpenButtonsSearch(false);
    setProcIdSearch(0);
    const name = isReceipt ? "sandmq" : "sandms";
    reloadGetsSanad(name, branch.id, onShow, defaultV);
  };
  const addChangds = () => {
    object.date =
      moment(object.date).format("YYYY-MM-DD") +
      moment(new Date()).format(" h:mm A");
    object.branch = formType === "edit" && !props.isDialogData ? branchT : props.isDialogData ? props.invData.branch : branch.id == -1 ? sto.branchi : branch.id;

  };
  const onSubmitHandle = (isPrint, isLarge = false) => {
    if (prmis?.FORCECOST === true && object?.center?.id < 1) {
      alert("لا يمكنك إتمام العملية برجاء التأكد من اختيار مركز التكلفة");
    } else {
      onSubmitHandleSave(isPrint, isLarge);
    }
  };

  const onSubmitHandleSave = async (isPrint) => {
    addChangds();
    let nData = PrepareDataWithOmla(object, isReceipt);

    console.log("n data is", nData);

    if (object.rows?.length == 0) {
      toast.error("يجب إضافة بيانات الى الجدول")
    }
    else {
      if (formType == "edit") {
        if (isPrint) {
          handlePrint(nData, object);
        }
        else {
          await update(nData).then((res) => {
            if (file) { addArchaive(res.data); }
            if (res.data?.id == null) {
              toast.error(res.data);

            } else {

            }
          })
        }
      }
      else {
        await submit(nData).then((res) => {
          if (file) { addArchaive(res.data); }
          if (isPrint) {
            handlePrint(res.data, object);
            console.log("the resdata data is ", res.data);

          }
        });
      }
    }


  };
  const [dataPrint, setDataPrint] = useState({});
  const [infoPrint, setInfoPrint] = useState(false);
  const closePrint = async (type) => {
    setDataPrint({});
    setInfoPrint(false);
    await newEReceipt();
  };
  const handlePrint = (rptdata, oldObject) => {
    const info = {
      data: oldObject.rows,
      tot: null,
      type: 2,
      sandId: rptdata.id,
      kind: isReceipt,
      userName: GetItemFromOptions(rptdata?.sales_emp ?? 1, AutoOptions.Users).name ?? "",
      title: isReceipt ? 'سند قبض متعدد' : 'سند صرف متعدد',
      stockName: oldObject?.type == '1' ? oldObject.stock.name : oldObject.bank.name,
      dataH: formType == "edit" ? oldObject : rptdata,
      type: oldObject?.type,
      notes: oldObject?.notes === isReceipt ? 'سند قبض متعدد' : 'سند صرف متعدد' + " " + "رقم" + ":" + oldObject?.id ? "" : oldObject.notes,
      nDate: moment(new Date).format("YYYY-MM-DD"),
      tDate: "00:00:00",
    };
    setDataPrint(info);
    setInfoPrint(true);
  };

  const onRowClick = (row, dataSub) => {
    setBranchT(row?.branch);
    setProcIdSearch(row.id);
    setOpenButtonsSearch(true);
    const tb = {
      Stocks: true, // Error // out
      parms: {
        branch: row?.branch,
        ibranchid: row?.branch,
        iempid: sto.empi,
        withOmlat: true,
      },
    };

    axios
      .post(uri + "Res", tb)
      .then((res) => {
        setOptionsStocks(res.data?.Stocks);
        const optinsNew = {
          ...AutoOptions,
          Stocks: res.data?.Stocks,
        };
        onRowClickAfter({ ...row }, dataSub, optinsNew);
      })
      .catch((error) => {
      });
  };

  const onRowClickAfter = (row, dataSub, optinsNew) => {
    setBranchT(row?.branch);
    let FormatedData = ReFormatingMultiData(row, dataSub, optinsNew, isReceipt);
    onShow(FormatedData, 'edit');
    setOpenSearchMdl(false);
  };
  const onClickButton = async (procId, type) => {
    const tb = {
      wait: true,
      ButtonSearchMultiSand: true,
      stor: sto,
      parms: {
        tname: type,
        branch: sto.branchi,
        iprocid: procId,
        iempid: sto.idi,
        type: isReceipt ? "1" : "0",

      },
    };
    axios
      .post(uri + "GetD", tb)
      .then((res) => {
        setProcIdSearch(res.data?.MultiSand_data?.id);
        if (res.data?.MultiSand_data.id > 0) {
          DataSubSearch({
            ...res.data.MultiSand_data,
            emp: res.data.MultiSand_data?.sales_emp,
            omla: res.data.MultiSand_data?.omla == null ? 1 : res.data.MultiSand_data?.omla,
            omlaval: res.data.MultiSand_data?.omlaval == null ? 1 : res.data.MultiSand_data?.omlaval,
          });
        }
      })
      .catch((error) => {
      });
  };
  const DataSubSearch = async (data) => {
    let typee = isReceipt ? 2 : 1;
    await axios
      .get(
        uri +
        `AccountReports/MultiSandsSubSearch?branch=${data?.branch}
    &&sandId=${data?.id}&&type=${typee}`
      )
      .then((res) => {
        if (res.data) {
          onRowDialog({ ...data }, res?.data?.multiSubData);
        } else {
          onRowDialog({ ...data }, res?.data?.multiSubData);
        }

      })
      .catch((err) => {
        console.log(err);
      });

  };

  const FromDialog = async () => {
    if (props.isDialogData === true) {
      let data = props.invData;
      let typee = isReceipt ? 2 : 1
      let newData = {
        ...data,
        omla: data?.omla == null ? 1 : data?.omla,
        omlaval: data?.omlaval == null ? 1 : data?.omlaval,
      };

      await axios
        .get(
          uri +
          `AccountReports/MultiSandsSubSearch?branch=${data?.branch}
    &&sandId=${data?.id}&&type=${typee}`
        )
        .then((res) => {
          if (res.data) {
            onRowDialog({ ...newData }, res?.data?.multiSubData);
          } else {
            onRowDialog({ ...newData }, res?.data?.multiSubData);
          }

        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  const onRowDialog = (row, dataSub) => {
    let FormatedData = ReFormatingMultiData(row, dataSub, AutoOptions, isReceipt);
    onShow(FormatedData, 'edit');
    setOpenSearchMdl(false);
  }

  useEffect(() => {
    FromDialog();
  }, []);


  const [loading, setLoading] = useState(insh.LoadAndSucc);

  const [success, setSuccess] = useState(insh.LoadAndSucc);
  const [confirmDialog, setConfirmDialog] = useState({ isOpen: false });

  const ButtonLoading = (prop) => {
    setLoading({ ...loading, [prop]: true });
  };
  const timer = React.useRef();

  const ButtonSuccess = (prop, state) => {
    timer.current = window.setTimeout(() => {
      setLoading({ ...loading, [prop]: false });
      setSuccess({ ...success, [prop]: true });
      if (
        prop == "delete"
      ) {
        if (state) newObject();
      }
      timer.current = window.setTimeout(() => {
        setSuccess({ ...success, [prop]: false });
      }, 100);
    }, 1000);
  };
  const newObject = () => {
    newEReceipt();
  };

  const onDeleteHandle = async (e) => {
    await e.preventDefault();
    setConfirmDialog({ ...confirmDialog, isOpen: false });
    ButtonLoading("delete");

    if (isReceipt) {
      await axios.delete(uri + `MultiQs?id=${object.id}&&branch=${object.branch}`).then(res => {

        if (parseFloat(res.data) > 0) {
          toast.success("لقد تم حذف السند بنجاح");

          if (props.isDialogData === true) {
            props.onClose();
          } else { ButtonSuccess("delete", true); }

        } else {
          toast.error(res.data);
          if (props.isDialogData === true) {
            { props.onClose(); }
          } else { ButtonSuccess("delete", true); }
        }
      }).catch(err => {
        if (err.response?.data?.Message != null) {
          toast.error(err.response?.data?.Message);
        } else
          console.log("eror", err)
        ButtonSuccess("delete", false);
        toast.error("not delete ")
      })
    } else {
      await axios.delete(uri + `MultiSbds?id=${object.id}&&branch=${object.branch}`).then(res => {

        if (parseFloat(res.data) > 0) {
          toast.success("لقد تم حذف السند بنجاح");

          if (props.isDialogData === true) {
            props.onClose();
          } else { ButtonSuccess("delete", true); }

        } else {
          toast.error(res.data);
          if (props.isDialogData === true) {
            { props.onClose(); }
          } else { ButtonSuccess("delete", true); }

        }
      }).catch(err => {
        if (err.response?.data?.Message != null) {
          toast.error(err.response?.data?.Message);
        } else
          console.log("eror", err)
        ButtonSuccess("delete", false);
        toast.error("not delete ")
      })
    }

  };


  const backHome = () => {
    if (isDialog)
      onClose();
    else {
      his.push({ pathname: '/', });
      window.location.reload(false);
    }
  };


  return (
    <React.Fragment>
      <Toaster />
      <CssBaseline />
      <AppBar position="fixed"
        className={clasBA.appBarBASal}
        style={{ backgroundColor: '#808080', }}
      >
        <Toolbar className={clasBA.ToolbarBA}
          variant="dense"
        >

          <Hidden smUp={['sm']}>
            <IconButton edge="start" color="inherit" aria-label="backH"
              onClick={backHome}
            >
              <CloseIcon />
            </IconButton>
            <IconButton edge="start" color="inherit" aria-label="searsh"
              onClick={() => setOpenSearchMdl(true)}
              disabled={prmis?.Se}
            >
              <SearchIcon />
            </IconButton>
            <IconButton edge="start" color="inherit" aria-label="handNew"
              onClick={newEReceipt}
            >
              <AddBoxIcon />
            </IconButton>
          </Hidden>

          <Hidden only={['xs']}>
            <Button
              style={styBtn.undis}
              onClick={backHome}
              startIcon={<CloseIcon />} >{t('exit')}</Button>
            <Button
              style={styBtn.undis}
              disabled={prmis?.Se}
              onClick={() => setOpenSearchMdl(true)}
              startIcon={<SearchIcon />}>{t('search')}</Button>
            <Button
              style={styBtn.undis}
              onClick={newEReceipt}
              startIcon={<AddBoxIcon />}>{t('new')}</Button>
          </Hidden>

          {!props.isDialogData && (
            <Hidden only={["xs"]}>
              <ButtonsSearch
                {...{
                  onClickButton, openButtonsSearch, procIdSearch, setOpenButtonsSearch
                }}
              />
            </Hidden>
          )}
          <div className={clasBA.growBA} />

          <Hidden smUp={['sm']}>
            {object.formType == 'edit' &&
              <div className={clasCAB.wrapperCAB}>
                <Fab size="medium" color="primary"
                  style={{ ...stElemnt.all.iconBtn, backgroundColor: '#808080' }}
                  className={clasCAB.buttonSuccessCAB}
                  onClick={(e) => {
                    setConfirmDialog({
                      isOpen: true,
                      onConfirm: () => {
                        onDeleteHandle(e);
                      },
                    })
                  }}
                >
                  <Delete />
                </Fab>

                {submitting && <CircularProgress size={56} className={clasCAB.fabProgressCAB} />}
              </div>
            }

            <div className={clasCAB.wrapperCAB}>
              <Fab size="medium" color="primary"
                style={{ ...stElemnt.all.iconBtn, backgroundColor: '#808080' }}
                className={clasCAB.buttonSuccessCAB}
                disabled={submitting || (formType == "new" ? (prmis?.Sa || prmis?.Pr) : prmis?.Pr)}
                onClick={() => { onSubmitHandle(true) }}
              ><PrintIcon />
              </Fab>
              {submitting && <CircularProgress size={56} className={clasCAB.fabProgressCAB} />}
            </div>

            <div className={clasCAB.wrapperCAB}>
              <Fab size="medium" color="primary"
                style={{ ...stElemnt.all.iconBtn, backgroundColor: '#808080' }}
                className={clasCAB.buttonSuccessCAB}
                disabled={submitting || (formType == "new" ? prmis?.Sa : prmis?.Up)}
                onClick={() => onSubmitHandle(false)}
              > <SaveIcon />
              </Fab>

              {submitting && <CircularProgress size={56} className={clasCAB.fabProgressCAB} />}
            </div>

          </Hidden>

          <Hidden only={['xs']}>


            {formType == "edit" && (
              <>
                <div className={clasCAB.wrapperCAB}>
                  <Button
                    variant="contained"
                    color="primary"
                    size="large"
                    className={clasCAB.buttonSuccessCAB}
                    startIcon={<Delete />}
                    style={{
                      ...stElemnt.all.iconBtn,
                      backgroundColor: "#808080",
                    }}
                    //disabled={submitting || prmis.De}
                    onClick={(e) => {
                      setConfirmDialog({
                        isOpen: true,
                        onConfirm: () => {
                          onDeleteHandle(e);
                        },
                      })
                    }}
                  >
                    حـذف
                  </Button>

                  {submitting && (
                    <CircularProgress
                      size={24}
                      className={clasCAB.buttonProgressCAB}
                    />
                  )}
                </div>

              </>
            )}

            <Fragment>
              <div className={clasCAB.wrapperCAB}>
                <Button variant="contained" color="primary" size="large"
                  className={clasCAB.buttonSuccessCAB}
                  startIcon={<PrintIcon />}
                  style={{ ...stElemnt.all.iconBtn, backgroundColor: '#808080' }}
                  disabled={submitting || (formType == "new" ? (prmis?.Sa || prmis?.Pr) : prmis?.Pr)}
                  onClick={() => onSubmitHandle(true)}
                > {formType == 'edit' ? t('print') : t('save-print')}</Button>
              </div>
            </Fragment>
            <div className={clasCAB.wrapperCAB}>
              <Button variant="contained" color="primary" size="large"
                style={{ ...stElemnt.all.iconBtn, backgroundColor: '#808080' }}
                className={clasCAB.buttonSuccessCAB}
                disabled={submitting || (formType == "new" ? prmis?.Sa : prmis?.Up)}
                onClick={() => onSubmitHandle(false)}
                startIcon={<SaveIcon />}>{formType == 'edit' ? t('save-update') : t('save')}</Button>

            </div>

          </Hidden>

        </Toolbar>
      </AppBar>
      {confirmDialog.isOpen && (
        <DeleteConfirmDialog
          confirmDialog={confirmDialog}
          setConfirmDialog={setConfirmDialog}
        />
      )}
      {openSearchMdl && (
        <MultiSandsSearchCon
          {...{
            openSearchMdl, handCloseDw,
            onRowClick, URL, AutoOptions, transition, isReceipt, AutoOptionsB
          }}
        />
      )}
      {infoPrint ? <PrintMultiSands dataPrint={dataPrint} closePrint={closePrint} infoPrint={infoPrint} /> : null}

    </React.Fragment>
  );




};

